export default __webpack_public_path__ + "static/media/slides_2.807b46ff.jpg";